import React, { Component, Fragment } from "react";

import { connect } from "react-redux";
import { auth } from "../../Firebase/firebase";
import * as actionCreators from "../../Store/actions/index";
import Authentication from "../Authentication/Authentication";
import MainToolBar from "../../Component/Navigation/MainToolBar/MainToolBar";
import Spinner from "../../Component/UI/spinner/Spinner";
import MessagesPage from "../../Component/Messages/MessagesPage";

class Messages extends Component {
    state = {
        searchInput: '',
        showAuth: false,
        authMode: 'signIn'
    }

    componentDidMount() {
        let token = localStorage.getItem('idToken');
        if (!token) {
            const fireUser = auth.currentUser
            if (fireUser) {
                fireUser.getIdToken(true)
                    .then(responseToken => {
                        token = responseToken
                    })
                    .catch(error => console.log(error))
            }
            else {
                console.log(fireUser)
            }
        }
        this.props.onGetMessages(token)
        this.props.onGetAllUsers(token)
    }

    searchInputHandler = (value) => {
        this.setState({
            searchInput: value
        })
    }

    reLoadSearchPageHandler = () => {
        //  console.log('tes')
    }

    showAuthHandler = (mode, kepShowing) => {
        if (kepShowing) {
            this.setState({ showAuth: true })
        } else {
            this.setState((prevState) => {
                return { showAuth: !prevState.showAuth }
            })
        }
        if (mode === 'signUp') {
            this.setState({
                authMode: 'signUp'
            })
        }
        else if (mode === 'signIn') {
            this.setState({
                authMode: 'signIn'
            })
        }
        else if (mode === 'passwordReset') {
            this.setState({
                authMode: 'passwordReset'
            })
        }
        else if (mode === 'verifyEmail') {
            this.setState({
                authMode: 'verifyEmail'
            })
        }
    }

    render() {
        let messages = null;
        if (this.props.messages && this.props.allUsers) {
            messages = <MessagesPage
                messages={this.props.messages}
                routeProp={this.props.history}
                allUsers={this.props.allUsers} 
                onCleanChat={this.props.onCleanChat}/>
        }
        return (
            <Fragment>
                {this.state.showAuth ?
                    <Authentication
                        showAuth={this.state.showAuth}
                        showAuthHandler={this.showAuthHandler}
                        authMode={this.state.authMode} />
                    :
                    null}
                <MainToolBar searchInput={(value) => { this.searchInputHandler(value) }}
                    searchInputValue={this.state.searchInput}
                    props={{ ...this.props }}
                    reLoadSearchPage={this.reLoadSearchPageHandler}
                    showAuthHandler={this.showAuthHandler}
                    user={this.props.user}
                />
                {this.props.messageLoading ?
                    <Spinner />
                    :
                    messages
                }
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        messageLoading: state.Messages.messageLoading,
        messages: state.Messages.messages,
        //all dealer:
        allUsers: state.Messages.allUsers,
        // Auth related : 
        user: state.Auth.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onGetMessages: (token) => { dispatch(actionCreators.getMessages(token)) },
        onGetAllUsers: (token) => { dispatch(actionCreators.getAllUsers(token)) },
        onCleanChat: () => { dispatch(actionCreators.cleanChat()) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Messages);